import { useQuery } from '@tanstack/react-query';

import { authFetch } from '@verantos-dev/core-utils';
import type { ObjectResponse } from '@verantos-dev/types-common';

import { analysisKeys } from './queryKeys';
import type { AnalysisReadiness } from './types';

interface UseAnalysisReadinessQueryArgs {
  projectId: string;
  analysisProfileId: string;
  /** The profile's latest saved version — readiness is only defined for it, and a
   *  save (new version id) yields a fresh cache entry. */
  latestVersionId: string | null;
  enabled?: boolean;
}

// The same check the process endpoint enforces, listing every blocker. Depends on
// state outside this analysis (cohort runs, variable status), so it is refetched
// on mount/focus (default staleTime 0) and invalidated by RA resource updates.
export const useAnalysisReadinessQuery = ({
  projectId,
  analysisProfileId,
  latestVersionId,
  enabled = true,
}: UseAnalysisReadinessQueryArgs) =>
  useQuery({
    queryKey: analysisKeys.readiness(analysisProfileId, latestVersionId ?? ''),
    queryFn: () =>
      authFetch<ObjectResponse<AnalysisReadiness>>(
        `/analyses/${encodeURIComponent(projectId)}` +
          `/analysis-profile/${encodeURIComponent(analysisProfileId)}/readiness`
      ),
    enabled:
      enabled && projectId.length > 0 && analysisProfileId.length > 0 && latestVersionId !== null,
    retry: false,
    refetchOnWindowFocus: true,
  });
